export default __webpack_public_path__ + "static/qacase3-ee1015592f1339e8cb4845a31d04e1fe.png";